import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import React from 'react'

const AccomodationRowNoData = ({ colSpan }) => {
  const { t } = useLocalize()
  return (
    <tr>
      <td colSpan={colSpan} className="tw-p-8 tw-text-center">
        <p className="tw-text-content-base tw-opacity-70">
          {t('businessTrip.no-data')}
        </p>
      </td>
    </tr>
  )
}

export default AccomodationRowNoData
